import { render, staticRenderFns } from "./AssistantForm.vue?vue&type=template&id=a155a734&scoped=true&"
import script from "./AssistantForm.vue?vue&type=script&lang=ts&"
export * from "./AssistantForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a155a734",
  null
  
)

export default component.exports